module.exports = __webpack_public_path__ + "static/img/img.3efbb7d4.png";